import React from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import { CalendarMonthOutlined, CheckCircle, Close, List, MapOutlined, RadioButtonUnchecked } from '@mui/icons-material';

const viewOptions = [
    { id: 'map', label: 'Mappa', description: 'Esplora i tavoli vicino a te', icon: MapOutlined },
    { id: 'list', label: 'Lista', description: 'Tutti i dettagli, a colpo d’occhio', icon: List },
    { id: 'calendar', label: 'Calendario', description: 'Trova il giorno giusto per te', icon: CalendarMonthOutlined },
];

export default function ViewSelectionDialog({ open, selectedView, onClose, onSelect }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="view-selection-title"
            aria-describedby="view-selection-description"
            fullWidth
            maxWidth="xs"
            PaperProps={{ sx: { m: 2, width: 'calc(100% - 32px)', borderRadius: '22px', bgcolor: 'background.default' } }}
            slotProps={{ backdrop: { sx: { bgcolor: 'rgba(28,28,26,0.34)', backdropFilter: 'blur(4px)' } } }}
        >
            <DialogTitle id="view-selection-title" sx={{ pt: 4, pr: 5, pb: 1, color: 'primary.main', fontSize: 24, fontWeight: 700 }}>
                Come vuoi esplorare?
            </DialogTitle>
            <IconButton aria-label="Chiudi" onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}>
                <Close />
            </IconButton>
            <DialogContent sx={{ pb: 3 }}>
                <Typography id="view-selection-description" variant="body2" sx={{ color: 'text.secondary', mb: 2.5 }}>
                    Scegli come scoprire i prossimi tavoli.
                </Typography>
                <Stack spacing={1.25}>
                    {viewOptions.map(({ id, label, description, icon: Icon }) => {
                        const selected = selectedView === id;

                        return (
                            <Button
                                key={id}
                                aria-pressed={selected}
                                onClick={() => onSelect(id)}
                                variant="outlined"
                                fullWidth
                                sx={{
                                    justifyContent: 'flex-start',
                                    textAlign: 'left',
                                    gap: 1.5,
                                    p: 1.5,
                                    minHeight: 80,
                                    borderRadius: '13px',
                                    borderColor: selected ? 'primary.container' : 'outline.variant',
                                    bgcolor: selected ? '#fff0f1' : 'background.paper',
                                    boxShadow: selected ? 'inset 0 0 0 1px #8a0030' : 'none',
                                }}
                            >
                                <Icon sx={{ fontSize: 26, flexShrink: 0 }} />
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                    <Typography component="span" sx={{ display: 'block', fontWeight: 700, fontSize: 16 }}>
                                        {label}
                                    </Typography>
                                    <Typography component="span" variant="caption" sx={{ display: 'block', mt: 0.5, color: 'text.secondary', fontWeight: 400 }}>
                                        {description}
                                    </Typography>
                                </Box>
                                {selected
                                    ? <CheckCircle sx={{ fontSize: 22, color: 'primary.container' }} />
                                    : <RadioButtonUnchecked sx={{ fontSize: 22, color: 'outline.variant' }} />}
                            </Button>
                        );
                    })}
                </Stack>
            </DialogContent>
        </Dialog>
    );
}
